import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/GoogleButton/GoogleButton.tsx
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { Button } from "../Button/Button.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function GoogleButton({ ref, className = "", children, ...rest }) {
  const { t } = useComponentsTranslation();
  const classes = ["buyscout-google-btn", className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs(
    Button,
    {
      ref,
      variant: "outlined",
      color: "neutral",
      className: classes,
      ...rest,
      children: [
        /* @__PURE__ */ jsx(GoogleGLogo, {}),
        children ?? t("googleButton.signIn")
      ]
    }
  );
}
GoogleButton.displayName = "GoogleButton";
function GoogleGLogo() {
  return /* @__PURE__ */ jsx("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsx("path", { fill: "#FFC107", d: "M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" }),
    /* @__PURE__ */ jsx("path", { fill: "#FF3D00", d: "M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" }),
    /* @__PURE__ */ jsx("path", { fill: "#4CAF50", d: "M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" }),
    /* @__PURE__ */ jsx("path", { fill: "#1976D2", d: "M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" })
  ] }) });
}
export {
  GoogleButton
};
//# sourceMappingURL=GoogleButton.mjs.map